import router from './../router';
import { operateList } from './../router/operate'


function modifyNames(array) {
		return array.map(item => {
			let routerInfo: any = {}
			if(item.code) {
				routerInfo = {
					path: '/operate'+item.code,
					name: 'Operate'+item.code,
					meta: {
					  icon: '',
					  router: false,
					  title: item.name,
					},
					redirect: item.children[0].path,
					children: item.children ? modifyNames(item.children) : [] // 递归处理子项，如果存在的话
				}
			} else {
				routerInfo = {
					path: item.path,
					name: item.index_path,
					component: operateList[item.component],
					meta: {
						title: item.name,
						icon: '',
						menuType: 'Menu'
					},
					children: item.children ? modifyNames(item.children) : [] // 递归处理子项，如果存在的话
				}
			}
			return routerInfo
		});
	}

export const getMenu = () => {
		let data = sessionStorage.getItem('routerList')
		if(data) {
			// 代运营router动态添加
			let operateRouterList : any = JSON.parse(data)
			operateRouterList = modifyNames(operateRouterList);
			operateRouterList.forEach(item => {
				router.addRoute('Home', item)
			})
		}
		
	}